import { CSSProgressiveCaption01 } from "@caisy/league";
import styled from "styled-components";

export const SActiveUsersDropdownItemEmail = styled.p`
  ${CSSProgressiveCaption01};
  color: var(--text-03);
`;
